import { jsxs as t, jsx as o } from "react/jsx-runtime";
const s = (r) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...r,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          fill: "currentcolor",
          d: "M16.973 17.976C14.186 20.166 10.083 20.642 6.7 19L2 20l1.3-3.9C1.071 12.804 1.806 8.59 4.98 6.043M2 3l18 18ZM8.595 4.577c3.223-1.176 7.025-.61 9.65 1.63 2.982 2.543 3.601 6.523 1.636 9.66"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          stroke: "currentcolor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2,
          d: "M16.973 17.976C14.186 20.166 10.083 20.642 6.7 19L2 20l1.3-3.9C1.071 12.804 1.806 8.59 4.98 6.043M2 3l18 18M8.595 4.577c3.223-1.176 7.025-.61 9.65 1.63 2.982 2.543 3.601 6.523 1.636 9.66z"
        }
      )
    ]
  }
);
export {
  s as default
};
